import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import {useSelector} from 'react-redux';
import {useGlobalContext} from "../../contexts/GlobalContext";
import ButtonAction from '../../../../../app/modules/_common/components/ButtonAction';
import styles from './styles.module.scss';
import classnames from "classnames";

const UserDropdown = () => {
  const {user} = useSelector((state) => state.auth);
  const {handleGlassTheme, isGlassTheme} = useGlobalContext();

  return (
    <Dropdown drop="right" className={styles.glassDropdown}>
      <Dropdown.Toggle
        id="dropdown-toggle-user-profile"
        className={styles.glassToggle}
      >
        <div className={classnames(styles.glassBtn, isGlassTheme ? styles.jump : styles.noJump)}>
          <span className={styles.glassText}>{user.fullName}</span>
          <div className={styles.glassAvatar}>
            <span className={styles.glassInitials}>{user.initials}</span>
          </div>
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu menuAlign="center" className={styles.glassMenu}>
        <ButtonAction
          useIcon={'/media/common/Logout_white.svg'}
          variant={'logout'}
          customClassnames={'w-150px'}
        />
        <ButtonAction
          variant={isGlassTheme ? 'primary' : 'warning'}
          useIcon={'media/common/Magic-stick_white.svg'}
          label={isGlassTheme ? 'מצב בטוח מופעל' : 'מצב בטוח כבוי'}
          onClick={handleGlassTheme}
          customClassnames={'ml-4 w-200px'}
          avoidDoubleClick={false}
        />
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default UserDropdown;
